import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TerrainIcon(props: IconProps) {
    return <Icon {...props} iconKey={"terrain"}/>
}
